import { render, staticRenderFns } from "./GlasswareVolume.vue?vue&type=template&id=2cb7800f&scoped=true&"
import script from "./GlasswareVolume.vue?vue&type=script&lang=js&"
export * from "./GlasswareVolume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7800f",
  null
  
)

export default component.exports